var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "vds-spark",
      style: {
        height: "".concat(_vm.height, "px")
      },
      attrs: {
        role: "presentation",
        "aria-hidden": "true"
      }
    },
    [
      _c("v-sparkline", {
        staticClass: "vds-spark__fill",
        attrs: {
          value: _vm.points,
          color: _vm.color,
          fill: "",
          smooth: _vm.smooth,
          "line-width": 0,
          padding: _vm.padding,
          width: _vm.viewWidth,
          height: _vm.height
        }
      }),
      _c("v-sparkline", {
        staticClass: "vds-spark__line",
        attrs: {
          value: _vm.points,
          color: _vm.color,
          smooth: _vm.smooth,
          "line-width": _vm.lineWidth,
          padding: _vm.padding,
          width: _vm.viewWidth,
          height: _vm.height,
          "stroke-linecap": "round",
          "auto-draw": "",
          "auto-draw-duration": _vm.duration
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }